import { render } from "./BasicUsage.vue?vue&type=template&id=54ee41ea"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script